import React from "react";
import { Navigate } from "react-router-dom";
import { auth } from "../components/firebase/firebaseInit";
import { useAuthState } from "react-firebase-hooks/auth";

const PrivateRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const [user, loading, error] = useAuthState(auth);
  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default PrivateRoute;
